module.exports = __webpack_public_path__ + "media/up.412f7059.mp3";